export default `import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;
import java.nio.charset.StandardCharsets;
import java.security.InvalidKeyException;
import java.security.NoSuchAlgorithmException;

public class CannyHashGenerator {

    private static final String APIKey = "YOUR_API_KEY";

    public static String generateCannyHash(String userId) throws NoSuchAlgorithmException, InvalidKeyException {
        Mac sha256_HMAC = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(APIKey.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
        sha256_HMAC.init(secretKey);

        byte[] hashBytes = sha256_HMAC.doFinal(userId.getBytes(StandardCharsets.UTF_8));
        StringBuilder hashString = new StringBuilder();
        for (byte b : hashBytes) {
            hashString.append(String.format("%02x", b));
        }
        return hashString.toString();
    }

    public static void main(String[] args) {
        try {
            String userId = "exampleUserID";
            String hash = generateCannyHash(userId);
            System.out.println("Generated Hash: " + hash);
        } catch (Exception e) {
            e.printStackTrace();
        }
    }
}`;
